import React from 'react';
import Document, {DocumentContext, Head, Html, Main, NextScript,} from 'next/document';
import {mediaStyles} from '../constants/media_query';

// avoid CSS animation transition flashing
export const DISABLE_SSR_TRANSITION = 'disable-SSR-transition';

export default class CustomDocument extends Document {
  static async getInitialProps(ctx: DocumentContext) {
    const initialProps = await Document.getInitialProps(ctx);
    return {...initialProps};
  }

  render() {
    return (
      <Html lang="en">
        <Head>
          <link rel="shortcut icon" href="/img/favicon.ico"/>
          <meta name="theme-color" content="#ffffff"/>
          <meta name="apple-mobile-web-app-capable" content="yes"/>
          <meta
            name="apple-mobile-web-app-status-bar-style"
            content="default"
          />
          <style
            type="text/css"
            dangerouslySetInnerHTML={{__html: mediaStyles}}
          />
          <script src="https://shequ-oss.obs.cn-east-2.myhuaweicloud.com/digit/exam/wangEditor.min.js" type="application/javascript"/>
          <script src="https://src.fanruan.com/2025-website/fanruan/js/global-qrcode-init.js"/>
        </Head>
        <body>
        <Main/>
        <NextScript/>
        <style
          id={DISABLE_SSR_TRANSITION}
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: '*, *::before, *::after { transition: none !important; }',
          }}
        />
        </body>
      </Html>
    );
  }
}
